/* eslint-disable no-console */
import type { IPublicTypeProjectSchema } from '@gant-lowcode/lowcode-types';
import CodeGen, { IProjectBuilderOptions } from './standalone';

declare const self: any;

if (typeof self !== 'undefined') {
  self.onmessage = (event: any) => {
    const msg = event.data || {};
    if (msg.type === 'run') {
      run(msg);
    }
  };

  self.postMessage({ type: 'ready' });
}
async function run(msg: {
  solution: string;
  builderOptions: IProjectBuilderOptions;
  schema: IPublicTypeProjectSchema;
  flattenResult?: boolean;
}) {
  try {
    print('begin run...');
    self.postMessage({ type: 'run:begin' });

    const { solution, builderOptions } = msg;
    if (!solution) {
      throw new Error('solution is required');
    }

    const createAppBuilder = CodeGen.solutions[solution as 'gant' | 'gantLegacy'];
    if (typeof createAppBuilder !== 'function') {
      throw new Error(`solution '${solution}' is invalid`);
    }

    const appBuilder = createAppBuilder(builderOptions);

    print('generating from schema: %o', msg.schema);

    const result = await appBuilder.generateProject(msg.schema);

    print('generated result: %o', result);

    const finalResult = msg.flattenResult
      ? CodeGen.utils.resultHelper.flattenResult(result)
      : result;

    if (msg.flattenResult) {
      print('flatten result: %o', finalResult);
    }

    self.postMessage({
      type: 'run:end',
      result: finalResult,
    });
  } catch (e) {
    printErr(`${e}`);
    self.postMessage({
      type: 'run:error',
      errorMsg: `${(e as Error | null)?.message || e}`,
      errorDetail: `${e}`,
    });
  }
}

function print(text: string, ...args: any[]) {
  console.debug(`[code-generator/worker]: ${text}`, ...args);
  self.postMessage({
    type: 'stdout',
    data: text,
    args,
  });
}

export const sendPrint = print;

function printErr(text: string, ...args: any[]) {
  console.debug(`[code-generator/worker]: %c${text}`, 'color:red', ...args);
  self.postMessage({
    type: 'stderr',
    data: text,
    args,
  });
}
